import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps } from '../../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../../utils/basecontext';
import { UIComponentView } from '../../../../../toolkit/uicomponentview';
import { ToneDto } from '../../../../../../core/dto/tonedto';
import { UIComponentCSSStyle } from '../../../../../toolkit/uicomponentcss';

import {  ArtistToneCardViewImpl } from './artisttonecardview';
import { ToneRowOptionsPrivilage } from 'src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonerowcomponent';
import { RoutingFeatures } from '../../../../navigation/routingfeature';
import { ToneCardCSSStyle } from '../tonecard/tonecardcssstyle';


export interface ArtistToneCardComponentProps extends UIComponentProps
{
    toneDto: ToneDto;
    position: number;
    cardStyle :ToneCardCSSStyle;
    marginTop: string;
    toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
}

export interface ArtistToneCardComponentState extends UIComponentState
{

   toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
}

export interface ArtistToneCardComponentHandler extends UIComponentHandler
{
    onArtistClick():void;
}

export class ArtistToneCardComponent extends UIComponentImpl<ArtistToneCardComponentProps, ArtistToneCardComponentState, UIDataModel> implements ArtistToneCardComponentHandler
{
    constructor(props: ArtistToneCardComponentProps)
    {
        super(props);

        this.state = {toneRowOptionsPrivilage: props.toneRowOptionsPrivilage};
    }

    onArtistClick(): void 
    {
        this.props.context.getRedirectionHandler().routeNextFeature(this.props.context.getRoutingPath() +
                "/" + RoutingFeatures.ARTIST_SEARCH + "?searchkey=" + this.props.toneDto.getArtistName(), false);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ArtistToneCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.props.cardStyle;
    }

    componentWillReceiveProps(nextProps: ArtistToneCardComponentProps)
    {
        this.setState({toneRowOptionsPrivilage: nextProps.toneRowOptionsPrivilage});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/artist/artisttonecardcomponent.tsx